import React from "react";

const GroupsIcon = ({ fill, width = 22.5, height = 18.742, style = {} }) => (
  <svg
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 22.5 18.742"
    style={{ width: "auto", height: "auto", ...style }}
  >
    <g id="group_2_" data-name="group (2)" transform="translate(0.25 0.25)">
      <g id="Group_9766" data-name="Group 9766" transform="translate(0 7.99)">
        <g id="Group_9765" data-name="Group 9765" transform="translate(0 0)">
          <path
            id="Path_1737"
            data-name="Path 1737"
            d="M18.777,231.333H16.624a3.214,3.214,0,0,0-.847.114A3.225,3.225,0,0,0,12.9,229.68H9.1a3.225,3.225,0,0,0-2.874,1.767,3.214,3.214,0,0,0-.847-.114H3.223A3.226,3.226,0,0,0,0,234.556V238a1.936,1.936,0,0,0,1.934,1.934H20.066A1.936,1.936,0,0,0,22,238v-3.443A3.226,3.226,0,0,0,18.777,231.333Zm-12.9,1.57v5.74H1.934A.645.645,0,0,1,1.289,238v-3.443a1.936,1.936,0,0,1,1.934-1.934H5.376a1.928,1.928,0,0,1,.506.068C5.877,232.76,5.874,232.831,5.874,232.9Zm8.963,5.74H7.163V232.9A1.936,1.936,0,0,1,9.1,230.969H12.9a1.936,1.936,0,0,1,1.934,1.934ZM20.711,238a.645.645,0,0,1-.645.645h-3.94V232.9c0-.072,0-.143-.008-.213a1.93,1.93,0,0,1,.506-.068h2.154a1.936,1.936,0,0,1,1.934,1.934Z"
            transform="translate(0 -229.68)"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <g id="Group_9768" data-name="Group 9768" transform="translate(1.436 3.557)">
        <g id="Group_9767" data-name="Group 9767" transform="translate(0 0)">
          <path
            id="Path_1738"
            data-name="Path 1738"
            d="M36.278,126.5a2.864,2.864,0,1,0,2.864,2.864A2.867,2.867,0,0,0,36.278,126.5Zm0,4.438a1.575,1.575,0,1,1,1.575-1.575A1.576,1.576,0,0,1,36.278,130.942Z"
            transform="translate(-33.414 -126.504)"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <g id="Group_9770" data-name="Group 9770" transform="translate(7.174 0)">
        <g id="Group_9769" data-name="Group 9769">
          <path
            id="Path_1739"
            data-name="Path 1739"
            d="M170.788,43.729a3.826,3.826,0,1,0,3.826,3.826A3.83,3.83,0,0,0,170.788,43.729Zm0,6.363a2.537,2.537,0,1,1,2.537-2.537A2.54,2.54,0,0,1,170.788,50.092Z"
            transform="translate(-166.962 -43.729)"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <g id="Group_9772" data-name="Group 9772" transform="translate(14.837 3.557)">
        <g id="Group_9771" data-name="Group 9771" transform="translate(0 0)">
          <path
            id="Path_1740"
            data-name="Path 1740"
            d="M348.158,126.5a2.864,2.864,0,1,0,2.864,2.864A2.867,2.867,0,0,0,348.158,126.5Zm0,4.438a1.575,1.575,0,1,1,1.575-1.575A1.576,1.576,0,0,1,348.158,130.942Z"
            transform="translate(-345.294 -126.504)"
            strokeWidth="0.5"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default GroupsIcon;
